// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { StepperContext } from "@werner/App/Widgets/CheckoutStepper/StepperContext";
import Edit from "@werner/XDL/Icons/Edit";
import { createLinkIconStyles, mergeWithCss } from "@werner/XDL/Utilities";
import React, { useContext, useState } from "react";
import { css } from "styled-components";

interface CheckoutMoveToStepProps {
    label?: string;
    moveToStep?: number;
    extendedStyles?: CheckoutMoveToStepStyles;
}

export interface CheckoutMoveToStepStyles {
    editLink?: LinkPresentationProps;
}

export const checkoutMoveToStepStyles: CheckoutMoveToStepStyles = {
    editLink: {
        ...createLinkIconStyles(Edit, {
            color: "secondary",
            typographyProps: {
                size: 15,
                weight: 400,
                css: css`
                    line-height: 32px;
                    letter-spacing: 0;
                `,
            },
            icon: {
                iconProps: {
                    size: 16,
                },
                position: "left",
            },
        }),
    },
};

const CheckoutMoveToStep = ({ label, moveToStep, extendedStyles }: CheckoutMoveToStepProps) => {
    const [styles] = useState(() => mergeWithCss(checkoutMoveToStepStyles, extendedStyles));
    const { moveToStepHandler } = useContext(StepperContext);
    const moveTo = () => {
        if (typeof moveToStep !== "number") {
            return;
        }

        moveToStepHandler(moveToStep);
    };

    if (typeof moveToStep !== "number") {
        return null;
    }

    return (
        <Link {...styles.editLink} aria-label={`move-to-${label}`} onClick={moveTo}>
            {translate(`Edit ${label || ""}`)}
        </Link>
    );
};

export default CheckoutMoveToStep;
